module.exports = __webpack_public_path__ + "static/BWA_in_jar.inline-5e603cb06cfab6740858e78dbd208a2c.svg";